import { memo, useEffect, useMemo, useState } from 'react'

import { FileItem } from '@inno-sdks/files'
import { Spinner } from '@inno-ui/spinner'
import { useGetFileItem } from 'modules/desktop/modules/files-integration/api'
import { Virtuoso } from 'react-virtuoso'

import { useItemModal } from '../../../hooks/useItemModal'
import styles from './TextPreview.module.scss'

export const TextPreview = memo(() => {
  const { itemId } = useItemModal()
  const { data: item } = useGetFileItem<FileItem>(itemId)

  const [content, setContent] = useState<string>()
  const [isLoading, setIsLoading] = useState(true)

  const lines = useMemo(() => content?.split('/n') ?? [], [content])

  useEffect(() => {
    if (!item?.metaData.presignedUrl) {
      return
    }

    const abortController = new AbortController()

    fetch(item.metaData.presignedUrl, {
      signal: abortController.signal
    })
      .then(res => res.text())
      .then(setContent)
      .catch(() => {})
      .finally(() => setIsLoading(false))

    return () => abortController.abort()
  }, [item?.metaData.presignedUrl])

  if (isLoading) {
    return (
      <div className={styles.loadingContainer}>
        <Spinner />
      </div>
    )
  }

  if (!content) {
    return null
  }

  return (
    <div className={styles.container}>
      <Virtuoso
        data={lines}
        totalCount={200}
        itemContent={(_, content) => <pre>{content}</pre>}
        increaseViewportBy={100}
      />
    </div>
  )
})
